// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-footer {
  border-top: none;
}
.modal-footer button {
  width: 160px;
  margin: 10px;
}

.check-icon i {
  width: 110px;
  height: 110px;
  padding: 40px;
  color: #DE1C3F;
  border-radius: 50%;
  background-color: #FFEBF0;
}

.modal-square {
  width: auto;
  max-width: 500px;
}

.modal-content {
  padding: 10px 0;
}

.zikata-dark-grey {
  color: #8C9295;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbmZpcm0tbG9nb3V0LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0ksZ0JBQUE7QUFDSjtBQUFJO0VBQ0UsWUFBQTtFQUNBLFlBQUE7QUFFTjs7QUFHSTtFQUNJLFlBQUE7RUFDQSxhQUFBO0VBQ0EsYUFBQTtFQUNBLGNBQUE7RUFDQSxrQkFBQTtFQUNBLHlCQUFBO0FBQVI7O0FBSUU7RUFDRSxXQUFBO0VBQ0EsZ0JBQUE7QUFESjs7QUFJRTtFQUNFLGVBQUE7QUFESjs7QUFJRTtFQUNFLGNBQUE7QUFESiIsImZpbGUiOiJjb25maXJtLWxvZ291dC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5tb2RhbC1mb290ZXIge1xuICAgIGJvcmRlci10b3A6IG5vbmU7XG4gICAgYnV0dG9uIHtcbiAgICAgIHdpZHRoOiAxNjBweDtcbiAgICAgIG1hcmdpbjogMTBweDtcbiAgICB9XG4gIH1cblxuICAuY2hlY2staWNvbiB7XG4gICAgaSB7XG4gICAgICAgIHdpZHRoOiAxMTBweDtcbiAgICAgICAgaGVpZ2h0OiAxMTBweDtcbiAgICAgICAgcGFkZGluZzogNDBweDtcbiAgICAgICAgY29sb3I6ICNERTFDM0Y7IC8vIHppa2F0YSByZWRcbiAgICAgICAgYm9yZGVyLXJhZGl1czogNTAlO1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjRkZFQkYwOyAvLyB6aWthdGEgcmVkLWFsdFxuICAgIH1cbiAgfVxuXG4gIC5tb2RhbC1zcXVhcmUge1xuICAgIHdpZHRoOiBhdXRvO1xuICAgIG1heC13aWR0aDogNTAwcHg7XG4gIH1cblxuICAubW9kYWwtY29udGVudCB7XG4gICAgcGFkZGluZzogMTBweCAwO1xuICB9XG5cbiAgLnppa2F0YS1kYXJrLWdyZXkge1xuICAgIGNvbG9yOiAjOEM5Mjk1O1xuICB9XG4iXX0= */`, "",{"version":3,"sources":["webpack://./libs/auth/src/lib/components/confirm-logout/confirm-logout.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AAAI;EACE,YAAA;EACA,YAAA;AAEN;;AAGI;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AAAR;;AAIE;EACE,WAAA;EACA,gBAAA;AADJ;;AAIE;EACE,eAAA;AADJ;;AAIE;EACE,cAAA;AADJ;AACA,gqCAAgqC","sourcesContent":[".modal-footer {\n    border-top: none;\n    button {\n      width: 160px;\n      margin: 10px;\n    }\n  }\n\n  .check-icon {\n    i {\n        width: 110px;\n        height: 110px;\n        padding: 40px;\n        color: #DE1C3F; // zikata red\n        border-radius: 50%;\n        background-color: #FFEBF0; // zikata red-alt\n    }\n  }\n\n  .modal-square {\n    width: auto;\n    max-width: 500px;\n  }\n\n  .modal-content {\n    padding: 10px 0;\n  }\n\n  .zikata-dark-grey {\n    color: #8C9295;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
